// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1crdC","header":"ReportDetails_header__3G_lr","title":"ReportDetails_title__F3BIC","left":"ReportDetails_left__2kE8E"};